import { ApostleClassId, ApostleClassType } from '@apeiron/apostle'
import { MayNull } from '@apeiron/temp'

export const toApostleClassId = (classType: MayNull<ApostleClassType>) => {
  if (!classType) {
    return null
  }

  return ApostleClassId[classType]
}

export const toApostleClassType = (classId: MayNull<ApostleClassId>) => {
  const key = Object.keys(ApostleClassType).find(key => {
    const typedKey = key as keyof typeof ApostleClassType

    return ApostleClassId[typedKey] === classId
  }) as keyof typeof ApostleClassType | undefined

  if (!key) {
    return undefined
  }

  return ApostleClassType[key]
}
